import { MULTI_SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { TransformedMultiSelectField } from '../types.tsx';

// TODO: update to compare by optionId once FLINGO-940 is done
const evaluateHandler: EvaluateHandler<TransformedMultiSelectField> = {
	CONTAINS: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => fieldValue && value?.includes(fieldValue.value))
					.length === value?.length,
		),
	HAS_ANY_OF: (field, value) =>
		Array.isArray(value) &&
		Boolean(field.value?.some((fieldValue) => fieldValue && value?.includes(fieldValue.value))),
	DOES_NOT_CONTAIN: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => fieldValue && value?.includes(fieldValue.value))
					.length !== value?.length,
		),
	IS_EMPTY: (field) => !field.value || field.value?.length === 0,
	IS_NOT_EMPTY: (field) => Boolean(field.value && field.value.length > 0),
};

const evaluateFormatRule: FormatRule<TransformedMultiSelectField> = ({
	field,
	operator,
	value,
}) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const multiSelectEvaluateFormatRule = {
	[MULTI_SELECT_CF_TYPE]: evaluateFormatRule,
};
